import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateItemIcon from '@material-ui/icons/Add'
import EditItemIcon from '@material-ui/icons/Ballot'
import DeleteItemIcon from '@material-ui/icons/DeleteForever'
import FilterIcon from '@material-ui/icons/FilterList'

import PaperBlock from "../../ui/PaperBlock"
import { Menu, MenuItem } from '@material-ui/core'

/**
 * 	<ControlPanel
 * 		selected
 *      onAddDewarClick = {}
 *      onEditDewarClick = {}
 *      onDeleteDewarClick = {}
 * 		onFilter = {}
 * 	/>
 */

class ControlPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			CompletionFilterButton_anchorEl: null,
		}
	}

	handle_CompletionFilterButton_click = (e) => {
		e.stopPropagation()
		this.setState({CompletionFilterButton_anchorEl: e.currentTarget})
	}

	handle_CompletionFilterButton_close = () => {
		this.setState({CompletionFilterButton_anchorEl: null})
	}

	handle_CompletionFilterButton_MenuItem_click = (filter) => {
		this.setState({CompletionFilterButton_anchorEl: null})
		this.props.onFilter(filter)		
	}

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			{/* Добавить */}

			<Tooltip title = "Добавить"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onAddDewarClick === "function") {
							this.props.onAddDewarClick()
						}
					}}
				>
					<CreateItemIcon />
				</Button>
			</div></Tooltip>

			{/* Редактировать */}

			<Tooltip title = "Редактировать"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditDewarClick === "function") {
							this.props.onEditDewarClick(this.props.selected)
						}
					}}
				>
					<EditItemIcon />
				</Button>
			</div></Tooltip>

			{/* Удалить */}

			<Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteDewarClick === "function") {
							this.props.onDeleteDewarClick(this.props.selected)
						}
					}}
				>
					<DeleteItemIcon />
				</Button>
			</div></Tooltip>

			{/* Фильтр */}

			<Tooltip title = "Фильтр выполнения"><div>
				<Button
					aria-owns = {this.state.CompletionFilterButton_anchorEl ? 'CompletionFilterButton_menu' : null}
					aria-haspopup = "true"
					onClick = {this.handle_CompletionFilterButton_click}
				>
					<FilterIcon />
				</Button>
			</div></Tooltip>

			<Menu
				id="CompletionFilterButton_menu"
				anchorEl={this.state.CompletionFilterButton_anchorEl}
				open={Boolean(this.state.CompletionFilterButton_anchorEl)}
				onClose={this.handle_CompletionFilterButton_close}
			>
				<MenuItem onClick={()=>{this.handle_CompletionFilterButton_MenuItem_click(0)}}>Активные</MenuItem>
				<MenuItem onClick={()=>{this.handle_CompletionFilterButton_MenuItem_click(1)}}>Завершенные</MenuItem>
				<MenuItem onClick={()=>{this.handle_CompletionFilterButton_MenuItem_click(2)}}>Все</MenuItem>
			</Menu>

		</PaperBlock>

	}

}

export default ControlPanel